$(function() {

	$.nette.ext('caSlide', {
		init: function() {
			this.init();
		},
		success: function() {
			this.init();
		}
	}, {
		init: function() {

			$('.ca-slide')
				.filter(function() {
					return ! $(this).data('initialized');
				})
				.each(function() {
					var $box = $(this);

					$box.data('initialized', true);

					$box
						.on('collapse.collapsable', function(e) {
							$(this).addClass('ca-collapsing');
						})
						.on('collapsed.collapsable', function(e) {
							$(this).removeClass('ca-collapsing');
						})
						.on('expand.collapsable', function(e) {
							$(this).addClass('ca-expanding');
						})
						.on('expanded.collapsable', function(e) {
							$(this).removeClass('ca-expanding');
						})
						.collapsable({
							fx: 'slide'
						});
				});

		}
	});

});
